import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileManagerFolderDetailsInput } from '../filemanager.models';
import { FileManagerService } from '../filemanager.service';

@Component({
    selector: 'pcode-folder-details-dialog',
    templateUrl: './folder-details-dialog.component.html',
    styleUrls: ['./folder-details-dialog.component.scss'],
    standalone: false
})
export class FileManagerFolderDetailsDialogComponent
{
	// create folder form
	_form: UntypedFormGroup = this.fb.group(
		{
			name: [null, [Validators.required]]
		});
	get name() { return this._form.get('name'); }

	// constructor
	constructor
		(
			private dialogRef: MatDialogRef<FileManagerFolderDetailsDialogComponent>,
			@Inject(MAT_DIALOG_DATA) private model: FileManagerFolderDetailsInput,
			private fb: UntypedFormBuilder,
			private fileManagerService: FileManagerService
		)
	{
	}

	// create folder
	createFolder(formDirective: FormGroupDirective)
	{
		this.fileManagerService.createFolder(this.name.value, this.model.currentDirectoryId).subscribe(
			() =>
			{
				formDirective.resetForm();
				this._form.reset();

				this.dialogRef.close({ created: true })
			},
			error =>
			{
				this.dialogRef.close({ created: false, error: error })
			}
		);
	}

	// close dialog
	closeDialog()
	{
		this.dialogRef.close({ created: false });
	}
}
